import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

export const AuthGuard: CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.ensureInitialized().then(() => {
    const isAuthed = auth.isAuthenticated();
    if (isAuthed) return true;
    return new RedirectCommand(router.createUrlTree(['/login']));
  });
};
